import React from "react"
import "./ProfileDropdownCounter.scss"

const ProfileDropdownCounter = props => {
  return <span className="counter-badge">{props.count}</span>
}

export default ProfileDropdownCounter
